export class Row {
  public id: string;
  public sortOrder: number = 0;
  public meta: any;
}
